import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 0.815rem;
  display: flex;
  align-items: center;
  text-transform: capitalize;
  color: ${p => p.theme.token('text-default')};
`;

export const Message = styled.span`
  margin-inline-start: 0.3rem;
`;
